const isIElasticSearchItemsResponse = (obj) => {
    var _a;
    const response = obj;
    return ((response === null || response === void 0 ? void 0 : response.hits) != undefined &&
        ((_a = response === null || response === void 0 ? void 0 : response.hits) === null || _a === void 0 ? void 0 : _a.total.value) !== undefined &&
        (response === null || response === void 0 ? void 0 : response.hits.hits) !== undefined);
};
export default isIElasticSearchItemsResponse;
